module.exports = __webpack_public_path__ + "img/矢量智能对象@2x(2).bcc0fb76.png";